/**
 * The masthead every page other than the homepage opens with: hand-written
 * eyebrow, one oversized line, and an optional lede. Keeping it in one place is
 * what makes seven separate pages read as one site.
 */
export default function PageHero({ eyebrow, title, lede, children }) {
  return (
    <section className="bg-[linear-gradient(180deg,#eaf4ec,#fbf8f0)] pb-12 pt-15">
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
        <p className="font-hand text-2xl text-coral">{eyebrow}</p>
        <h1 className="mt-1.5 max-w-[900px] font-display text-[clamp(34px,4.6vw,64px)] font-extrabold leading-[1.02] text-forest text-balance">
          {title}
        </h1>
        {lede && (
          <p className="mt-4.5 max-w-[660px] text-[19px] leading-[1.6] text-ink-soft text-pretty">
            {lede}
          </p>
        )}
        {children}
      </div>
    </section>
  );
}
